export default {
  saveSuccessMsg: 'Save Successfully!',
  changeLanguageTips: 'Switching language succeeded',
  modifyPwdSuccess: 'Password changed successfully',
  noFileMsgOrError: 'No file information or file error',
  immutableInfo: 'The student information cannot be modified',
  unknownError: 'unknownError, please contact the administrator!',
  expired: 'authentication has expired',
}
